import script from "./DeviceListAddInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceListAddInfo.vue?vue&type=script&setup=true&lang=js"

import "./DeviceListAddInfo.vue?vue&type=style&index=0&id=495e4fb7&scoped=true&lang=css"
script.__scopeId = "data-v-495e4fb7"

export default script